import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import ActionTable from "../../components/table/ActionTable";
import { CircularProgress } from "@mui/material";
import AppContext from "../../container/context";
import { mergeParams } from "../../helpers/helpers";

export default function Lista({ history, location }) {
  const [dados, setDados] = useState(
    mergeParams({ cicloId: 0, exibirInativas: false }, location)
  );
  const [lista, setLista] = useState([]);
  const [ciclos, setCiclos] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const { notification } = useContext(AppContext);

  useEffect(() => {
    carregarComboCiclos();

    if (dados.cicloId || dados.ativas) {
      listarUnidades();
    }
  }, []);

  const carregarComboCiclos = () => {
    api
      .get("ciclos/listar")
      .then((comboCiclos) => setCiclos(comboCiclos))
      .catch((err) =>
        notification("error", "Erro ao listar os ciclos: " + err)
      );
  };

  const listarUnidades = (filtrosEnviar = dados) => {
    setDados(filtrosEnviar);
    setCarregando(true);

    api
      .get("unidades/listar", filtrosEnviar)
      .then((unidades) => {
        setLista(unidades);
        setCarregando(false);
      })
      .catch((e) => {
        notification("error", "Erro ao listar as unidades");
        setCarregando(false);
      });
  };

  const filtros = {
    title: "Filtrar",
    form: {
      cicloId: {
        label: "Ciclo",
        type: "select",
        emptyItem: true,
        space: 10,
        value: dados.cicloId,
        array: {
          data: ciclos,
          value: "id",
          desc: "nome",
        },
      },
      exibirInativas: {
        type: "check",
        label: "Exibir inativas",
        space: 2,
        value: dados.exibirInativas,
      },
    },

    submit: {
      label: "Listar",
      action: listarUnidades,
    },

    urlParams: true,
    history,
    location,
  };

  const abrirUnidade = (registro) => {
    history.push(`/app/unidade/item/${registro.id}`);
  };

  const tRegistros = {
    title: "Unidades",
    onLineClick: abrirUnidade,
    newItemAction: () => history.push("/app/unidade/item/0"),

    columns: [
      {
        label: "Sequência",
        name: "sequencia",
      },
      {
        label: "Número",
        name: "numero",
      },
      {
        label: "Título",
        name: "titulo",
      },
      {
        label: "Ativa",
        name: "ativa",
        checkbox: true,
      },
    ],
    array: lista,
  };

  return (
    <div>
      <Form formData={filtros} />
      {carregando ? (
        <CircularProgress />
      ) : (
        <ActionTable structure={tRegistros} />
      )}
    </div>
  );
}
